import React, { useEffect, useId } from 'react'
// jquery $ is loaded globally and available to this component without import requirement

// See the jsonform documentation for required fields that must be passed in the data object

// shift4-utils.js validators (onValidate_TaskDesc, onValidate_TerminalList,
// onValidate_ApiInterfaceUniqueness) dereference componentConfig.deviceConfig.device and
// componentConfig.apiInterfaceConfig.apiInterface without guarding against missing
// containers. Config templates start out with an empty {} config, so normalize the shape
// here to keep those validators running instead of throwing.
function normalizeComponentConfig(loadedComponentConfig) {
    const loaded = loadedComponentConfig || {}
    return {
        ...loaded,
        deviceConfig: {
            ...loaded.deviceConfig,
            device: loaded.deviceConfig?.device || []
        },
        apiInterfaceConfig: {
            ...loaded.apiInterfaceConfig,
            apiInterface: loaded.apiInterfaceConfig?.apiInterface || []
        }
    }
}

const JsonForm = ({data}) => {
    // The visual editor renders several JsonForms at once (one per device type). A shared
    // DOM id would make every jQuery lookup resolve to the first form only, so give each
    // instance its own id. useId output contains ':' which is invalid in a CSS selector.
    const reactId = useId().replace(/:/g, '')
    const formId = `jsonformControlled${reactId}`
    const formSelector = `#${formId}`

    useEffect(() => {
        if (!data) return

        // make sure any previous jquery event handlers and jsonform fields have been removed before loading again with the current data
        $(formSelector).off()
        $(formSelector).empty()

        // jsonform.js sets originalConfig from this global window object. Set this before calling jsonForm jquery function so that it is available to its context
        window.componentConfig = normalizeComponentConfig(data.loadedComponentConfig)
        $(formSelector).submit(event => {
            event.preventDefault()
            console.log('event submit called', event)
            return false
        })

        // attach form change handler so that caller knows the form is dirty and can present option of saving data on navigation change
        if (data.onFormChange) {
            $(formSelector).on('input', data.onFormChange)
        }

        // render form
        // Clone schema to prevent jsonForm's processedOnRender mutation from persisting
        // across React StrictMode's double effect invocation, which causes AddEventGroup
        // to be skipped and DropDownControlledGroups to fail with "Length does not match"
        $(formSelector).jsonForm({ ...data, schema: structuredClone(data.schema) })

        // attach cancel handler if the caller provided it
        // scoped to this form so multiple rendered forms each wire up their own button
        if (data.onCancel) {
            const btnCancel = document.querySelector(`${formSelector} #btnCancel`)

            if (btnCancel) {
                btnCancel.addEventListener('click', data.onCancel);
            }
        }

        return () => {
            $(formSelector).off()
            $(formSelector).empty()
            window.componentConfig = null
        }

    }, [data, formSelector]); // Re-apply if props change

    return (
        <>
        <div className="jsonformContainer px-3">
            <form id={formId} onSubmit={(event) => {event.preventDefault(); return false}}></form>
        </div>
        <p className="fw-light ps-3 my-3">* Highlighted fields are required</p>
        </>
    );
};

export default JsonForm;
